<template>
<v-img src='https://storage.googleapis.com/donorconnection-df169.appspot.com/404.png' />
</template>


<script>
export default {
    
}
</script>